"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var oidc_client_1 = require("oidc-client");
var instance;
exports.UserManager = (function () {
    var createInstance = function (oidcConfig) {
        var object = new oidc_client_1.UserManager(oidcConfig);
        return object;
    };
    return {
        /**
         * Gets a UserManager class that returns methods for managing a user.
         */
        getInstance: function () {
            if (!instance) {
                throw new Error('An instance of UserManager has not been created, please call `userManager.createInstance()` at the root of your app.');
            }
            return instance;
        },
        /**
         * Creates a UserManager class.
         */
        createInstance: function (options) {
            if (!instance) {
                instance = createInstance(options);
                return;
            }
            else {
                return console.error('An instance of UserManager has already been created in this application.');
            }
        },
    };
})();
//# sourceMappingURL=userManager.js.map